<div class="request-type">
    <div class="title">Worum geht es bei Ihrer Anfrage?</div>


    <ng-container *ngFor="let item of salesConciergeRequestType  | keyvalue: returnZero; let i = index">

        <div class="type-list"
             [ngClass]="{'selected': (i === selectedRequestTypeIndex) || (item.value === salesConciergeRequestType[salesConciergeRequest?.requestType]), 'comment': selectedRequestTypeIndex === 3 && item.value === salesConciergeRequestType.OTHER_ISSUES}"
             (click)="setRequestType(i, item.value)">
            <div class="type-image">
                <img [title]="item.value" [src]="'./assets/images/' + item.key + '.png'"/>
            </div>
            <div class="type"> {{ item.value }}


                <div class="internal-comment"
                     *ngIf="(selectedRequestTypeIndex == 3 && item.value === salesConciergeRequestType.OTHER_ISSUES)">
                    <bd-labeled-textarea label="Ihre Nachricht*"
                                         placeholder="Max. 500 Zeichen"
                                         required
                                         maxlength="500"
                                         (ngModelChange)="setOtherIssuesMessage($event)"
                                         [(ngModel)]="salesConciergeRequest.otherIssuesMessage"
                                         rows="3"
                                         name="internalComment"
                                         limitTo="500">

                    </bd-labeled-textarea>
                </div>

            </div>

        </div>
    </ng-container>

</div>
